import { notify } from 'client/util';
import Constants, {
  DirectoryActionConsts,
  DirectoryNameConsts,
  DirectoryTypeConsts,
} from 'client/util/Constants';
import DirectoryDialogsHelper from 'client/directories/DirectoryDialogsHelper';
import LocalStorageService from 'client/util/LocalStorageService';

const directoriesRoute = 'directories';
const cloudDirectoriesRoute = 'cloud-directories';

function getType(path) {
  return path.indexOf(DirectoryTypeConsts.gSuite) !== -1
    ? DirectoryTypeConsts.gSuite
    : DirectoryTypeConsts.office365;
}

function getId(path, type) {
  let id = path.replace(`/${directoriesRoute}`, '');
  id = id.replace(`/${cloudDirectoriesRoute}`, '');
  id = id.replace(`/${type}`, '');
  id = id.replace(`/${DirectoryActionConsts.import_users}`, '');
  id = id.replace('/', '');

  return id;
}

export default function cloudDirectoryGuard(to, from, next) {
  const { path } = to;
  const activatedActionCheck = new RegExp(`/?directories/.*${DirectoryActionConsts.activated}$`);
  const errorActionCheck = new RegExp(`/?directories/.*/${DirectoryActionConsts.error}$`);
  const importUsersActionCheck = new RegExp(`/?directories/.*/${DirectoryActionConsts.import_users}$`);
  const reactivatedActionCheck = new RegExp(`/?directories/.*/${DirectoryActionConsts.reactivated}$`);
  let route; // undefined means continue;

  // Don't stop at logout
  if (path.indexOf('/logout') === 0) {
    next();
    return;
  }

  if (activatedActionCheck.test(path)) {
    const toImportUsers = path.replace(
      DirectoryActionConsts.activated, DirectoryActionConsts.import_users,
    );
    route = toImportUsers;
  }

  if (importUsersActionCheck.test(path)) {
    const directoryType = getType(path);
    const directoryId = getId(path, directoryType);
    const toDetails = path.replace(
      DirectoryActionConsts.import_users, DirectoryActionConsts.details,
    );
    DirectoryDialogsHelper.showDirectoryImportUsersModal(
      directoryType,
      directoryId,
    );
    LocalStorageService.setItem('cloudDirectoryActivated', true);
    route = toDetails;
  }

  if (errorActionCheck.test(path)) {
    const typeName = DirectoryNameConsts[getType(path)];

    notify(
      Constants.error,
      `Unable to perform the requested action for the ${typeName} Directory.`,
    );

    route = `/${directoriesRoute}/${cloudDirectoriesRoute}`;
  }

  if (reactivatedActionCheck.test(path)) {
    const toDetails = path.replace(
      DirectoryActionConsts.reactivated, DirectoryActionConsts.details,
    );
    const typeName = DirectoryNameConsts[getType(path)];

    LocalStorageService.setItem('cloudDirectoryReactivated', true);
    notify(
      Constants.success,
      `The ${typeName} Directory was successfully ${DirectoryActionConsts.reactivated}.`,
    );
    route = toDetails;
  }

  next(route);
}
